import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import LocationsSection from './components/LocationsSection';
import Footer from '../../../components/feature/Footer';

const CarnitasDonLupePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Hero />

      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-zinc-900 mb-4">
            About Carnitas Don Lupe
          </h2>
          <p className="text-lg text-zinc-600 max-w-3xl mx-auto leading-relaxed">
            Carnitas Don Lupe specializes in authentic Mexican carnitas prepared using traditional slow-cooking 
            methods that have been perfected over decades. Our pork is carefully selected and cooked for hours 
            until it achieves the perfect balance of tenderness and flavor. Each bite delivers the authentic 
            taste of Michoacán-style carnitas that have made us a local favorite.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-restaurant-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Slow-Cooked</h3>
            <p className="text-zinc-600">Traditional Michoacán method for the most tender, flavorful carnitas</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-leaf-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Quality Ingredients</h3>
            <p className="text-zinc-600">Premium pork and fresh ingredients prepared daily</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Family Friendly</h3>
            <p className="text-zinc-600">Welcoming atmosphere perfect for families and gatherings</p>
          </div>
        </div>

        {/* Locations */}
        <LocationsSection />
      </div>

      <section className="bg-gradient-to-br from-orange-500 to-orange-600 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Visit Carnitas Don Lupe Today
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Experience authentic Michoacán-style carnitas prepared the traditional way
          </p>
          <Link
            to="/places-to-eat"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-full font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            Back to All Restaurants
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CarnitasDonLupePage;
